var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card p-shadow-app"},[_vm._m(0),_c('TabView',[_c('TabPanel',{attrs:{"header":"Logs"}},[_c('LogsDataTable')],1),_c('TabPanel',{attrs:{"header":"Service Order Attempts"}},[_c('LogServiceOrderAttemptsDataTable')],1)],1)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-d-flex p-jc-between p-mb-3"},[_c('h3',[_vm._v("Histórico de Logs")])])
}]

export { render, staticRenderFns }